import Col from "react-bootstrap/esm/Col";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import { Helmet } from "react-helmet";

type Props = {
    title: string;
    helmetTitle?: string;
};

const PlaceholderPage = ({ title, helmetTitle }: Props) => {
    return (
        <Container fluid>
            <Row>
                <Col>
                    <Helmet>
                        <title>{helmetTitle ?? title}</title>
                    </Helmet>
                    <h1 className="my-3">{title}</h1>
                </Col>
            </Row>
        </Container>
    );
};

export { PlaceholderPage };
